'use strict';

export default class Sorter {
	constructor(order = 'asc') {
        this.order = order;
    }

    setOrder(order) {
        this.order = order;
    }

    /**
     * A function that outputs:
     *  * x < 0: a is less than b
     *  * x = 0: a is equal to b
     *  * x > 0: a is greater than b
     * 
     * @param {HTMLElement} a 
     * @param {HTMLElement} b 
     * @returns either negative or positive integers
     */
    sort(a, b) {
        return 0;
    }
}